<template>
  <div>
    <el-card class="bj_card">
      <Body class="contentBox"></Body>
    </el-card>
  </div>
</template>

<script>

import Body from '../detail/body'

export default {
  components: {
    Body
  },
  data() {
    return {}
  },
  watch: {
    // $route(to, from) {
    //   console.log(to, from)
    // }
  }
}
</script>

<style lang="less" scoped>
.el-card {
  min-width: 1300px;
  min-height: 770px;
  position: relative;
}
</style>
